import { api } from '@/lib/axios';

export interface ConnectionDetails {
  serverUrl: string;
  token: string;
  room: string;
  identity: string;
  canPublish: boolean;
  role: 'HOST' | 'CO_HOST' | 'PARTICIPANT';
  isModerator: boolean;
}

export const livekitApi = {
  async getConnectionDetails(meetingId: string, participantId: string): Promise<ConnectionDetails> {
    const { data } = await api.post('/livekit/token', { meetingId, participantId });
    return data.data;
  },
  async admit(meetingId: string, participantId: string, admit: boolean): Promise<void> {
    await api.post(`/meetings/${meetingId}/admit`, { participantId, admit });
  },
};
